<nav #navbar class="navbar active">
  <div class="container-fluid">
    <div class="navbar-header">
      <a href="#" onClick="return false;" class="navbar-toggle collapsed"
        (click)="isNavbarCollapsed = !isNavbarCollapsed" aria-expanded="false"></a>
      <a href="#" onClick="return false;" class="bars" (click)="mobileMenuSidebarOpen($event,'overlay-open')"></a>
      <a class="navbar-brand" routerLink={{homePage}}>
        <img src="{{logoUrl}}" alt="" width="150" />
        <!-- <span class="logo-name">MedData</span> -->
      </a>
    </div>
    <div class="collapse navbar-collapse" [ngbCollapse]="isNavbarCollapsed">
      <ul class="pull-left collapse-menu-icon">
        <li>
          <button mat-icon-button (click)="callSidemenuCollapse()" class="sidemenu-collapse">
            <mat-icon>menu</mat-icon>
          </button>
        </li>
      </ul>
      <ul class="nav navbar-nav navbar-right">
        <li class="nav-item" ngbDropdown *ngIf="currentEmployee">
          <div class="d-flex flex-column align-items-end">
            <span>{{currentEmployee?.lastName}} {{currentEmployee?.firstName}}</span>
            <span class="nav-notification-title" #branch_name>{{currentClinic?.name}}</span>
          </div>
          <!-- <button mat-icon-button ngbDropdownToggle class="nav-notification-icons">
            <mat-icon>view_quilt</mat-icon>
          </button>
          <div ngbDropdownMenu class="notification-dropdown pullDown">

            <h5 class="text-center text-secondary d-block border-top py-1">
              {{'BRANCHES'|translate}}
            </h5>
            <div class="noti-list" style="position: relative; max-width: 600px; max-height: 250px;" [perfectScrollbar]>
              <ul class="menu">
                <ng-container *ngFor="let branch of clinicBranches$|async">
                  <li *ngIf="currentEmployee?.branchIds?.includes(branch.id)">
                    <a href="javascript:void(0)" (click)="switchToClinic(branch.id) "
                      [ngClass]="{active:branch.id === (currentClinicId$ | async)}" onClick="return false;">
                      <span class="table-img msg-user">
                        <img [src]="getClinicLogo(branch.logo)" alt="">
                      </span>
                      <span class="menu-info">
                        <span class="menu-title"> {{branch.name}}
                          <span *ngIf="branch.id === (currentClinicId$ | async)">*</span>
                        </span>
                      </span>
                    </a>
                  </li>
                </ng-container>

              </ul>
            </div>
          </div> -->
        </li>
        <!-- Full Screen Button -->
        <li class="fullscreen">
          <button mat-icon-button (click)="callFullscreen()" class=" nav-notification-icons">
            <mat-icon>fullscreen</mat-icon>
          </button>
        </li>
        <!-- #END# Full Screen Button -->
        <li class="nav-item" ngbDropdown>
          <a ngbDropdownToggle class="lang-dropdown">
            <!-- <img *ngIf="flagvalue !== undefined" src="{{flagvalue}}" height="16">
            <img *ngIf="flagvalue === undefined" src="{{defaultFlag}}" height="16"> -->
            {{getCountryNameDisplay}}
          </a>
          <div ngbDropdownMenu class="dropdown-menu lang-item dropdown-menu-right pullDown">
            <a href="javascript:void(0);" class="dropdown-item lang-item-list" *ngFor="let item of listLang"
              (click)="setLanguage(item.shortText, item.lang, item.flag)"
              [ngClass]="{'active': langStoreValue === item.lang}">
              <!-- <img src="{{item.flag}}" class="flag-img" height="12">  -->
              <span class="align-middle">{{item.text}}</span>
            </a>
          </div>
        </li>
        <!-- #START# Notifications-->
        <li class="nav-item" ngbDropdown>
          <button mat-icon-button ngbDropdownToggle class="nav-notification-icons">
            <mat-icon>notifications_none</mat-icon>
            <span class="{{notificationCount === 0 ? '' : 'label-count bg-orange'}}">{{notificationCount === 0 ? '' :
              notificationCount}}</span>
          </button>
          <div ngbDropdownMenu class="notification-dropdown pullDown">
            <div class="noti-list" style="position: relative; max-width: 400px; max-height: 600px;" [perfectScrollbar]>
              <meddata-notification-bar></meddata-notification-bar>
            </div>
            <a class="text-center d-block border-top py-1"
              [routerLink]="['/notification/notifications']">{{'NOTIFICATION.READ_ALL_NOTIFICATIONS'|translate}}</a>
          </div>
        </li>
        <!-- #END# Notifications-->
        <li class="nav-item user_profile" ngbDropdown>
          <a href="#" onClick="return false;" ngbDropdownToggle role="button" class="nav-notification-icons pt-0 p-2">
            <img src={{userImg}} class="rounded-circle" width="32" height="32" alt="User">
          </a>
          <div ngbDropdownMenu class="notification-dropdown pullDown">
            <div class="noti-list" style="position: relative; max-width: 600px; max-height: 300px;" [perfectScrollbar]>
              <ul class="menu">
                <li class="body">
                  <ul class="user_dw_menu">
                    <li *ngIf="profilePage">
                      <a routerLink="{{profilePage}}">
                        <mat-icon aria-hidden="false" class="me-2">person</mat-icon>{{'PROFILE'|translate}}
                      </a>
                    </li>
                    <ng-container *ngIf="personClinics?.length>1">
                      <li *ngFor="let clinic of personClinics"
                        [ngClass]="{active:clinic.tenantId=== (currentTenantId$ | async)}">
                        <a href="javascript:void(0)" (click)="switchToClinic(clinic.id)">
                          <img [src]="getClinicLogo(clinic.logo)" class="clinic-logo" height="12">
                          {{clinic.name}}
                          <span *ngIf="clinic.tenantId=== (currentTenantId$ | async)">*</span>
                        </a>
                      </li>
                    </ng-container>

                    <!-- <li>
                      <a routerLink="/doctor/become">
                        <mat-icon aria-hidden="false" class="me-2">person</mat-icon>{{'DOCTOR_BECOME'|translate}}
                      </a>
                    </li> -->
                    <!-- <li>
                      <a href="#" onClick="return false;">
                        <mat-icon aria-hidden="false" class="me-2">feedback</mat-icon>Feedback
                      </a>
                    </li> -->
                    <!-- <li>
                      <a href="#" onClick="return false;">
                        <mat-icon aria-hidden="false" class="me-2">help</mat-icon>Help
                      </a>
                    </li> -->
                    <li>
                      <a href="javascript:void(0);" (click)="logout()">
                        <mat-icon aria-hidden="false" class="me-2">power_settings_new</mat-icon>{{'LOGOUT'|translate}}
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </li>
        <!-- #END# Tasks -->
        <!-- <li class="pull-right">
          <button mat-icon-button (click)="toggleRightSidebar()" class="nav-notification-icons js-right-sidebar">
            <mat-icon id="settingBtn">settings</mat-icon>
          </button>
        </li> -->
      </ul>
    </div>
  </div>
</nav>